import React from "react";
import PropTypes from "prop-types";
import { LocalizedLink as Link } from "gatsby-theme-i18n";
import { StaticImage } from "gatsby-plugin-image";
import { LogoWrapper } from "./style";

const Logo = ({ className, variant, ...restProps }) => {
    return (
        <LogoWrapper className={className} $variant={variant} {...restProps}>
            <Link to="/">
                <StaticImage
                    placeholder="none"
                    src="../../assets/images/logo/logo.png"
                    className="img-fluid static-img light-logo"
                    alt="logo"
                    width={160}
                    height={48}
                />
                <StaticImage
                    placeholder="none"
                    src="../../assets/images/logo/logo.png"
                    className="img-fluid static-img dark-logo"
                    alt="logo"
                    width={160}
                    height={48}
                />
            </Link>
        </LogoWrapper>
    );
};

Logo.propTypes = {
    className: PropTypes.string,
    variant: PropTypes.oneOf(["white", "dark"]),
};

Logo.defaultProps = {
    justifyContent: "flex-start",
    variant: "dark",
};

export default Logo;
